import { Theme } from "@mui/material/styles";
import { createStyles, makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flex: 1,
      margin: `${theme.spacing(4)}px auto ${theme.spacing(2)}px`,
      maxWidth: 1200,
      width: "100%",
    },
    header: {
      paddingBottom: theme.spacing(1),
    },
    box: {
      display: "flex",
      flexDirection: "column",
      height: "100%",
    },
    boxContent: {
      flex: 1,
      paddingBottom: theme.spacing(1),
      paddingTop: theme.spacing(1),
    },
    boxDescription: {
      lineHeight: 1.4,
    },
    boxActions: {
      justifyContent: "flex-end",
      padding: theme.spacing(2),
    },
  })
);
